import { Redirect, Route, Switch } from 'react-router-dom';

import { DebtorKanban, InvoicesKanban } from './pages';

export const Kanban = () => (
  <Switch>
    <Route path="/kanban/invoices" component={InvoicesKanban} />
    <Route path="/kanban/customers" component={DebtorKanban} />
    <Redirect to="/kanban/invoices" />
  </Switch>
);
